import en from './localization/en'
import pl from './localization/pl'

export default {
  en,
  pl: {...en, ...pl}
}



// WEBPACK FOOTER //
// ./src/labels.js